import type {CreateExtArgs, CreateExtensionArgument, DmApis, Extension, ExtensionAPI} from '@wix/document-manager-core'
import type {Pointer} from '@wix/document-services-types'
import {getPageOutlineAndTargetsForBuilder, type BuilderOutlineWithIdMapAndTargets} from './aiBuilderGeneration'
import {
    buildSiteContext,
    analyze,
    type SiteContext,
    type AnalyzeParams,
    type AnalysisResult
} from './proactiveAssistance'

export interface ProactiveAssistanceApi {
    buildSiteContext(): Promise<SiteContext>
    extractContent(containerPointer: Pointer): BuilderOutlineWithIdMapAndTargets
    analyze(params: AnalyzeParams): Promise<AnalysisResult>
}

export type ProactiveAssistanceExtApi = ExtensionAPI & {proactiveAssistance: ProactiveAssistanceApi}

const createExtension = ({environmentContext}: CreateExtensionArgument): Extension => {
    const createExtensionAPI = (createExtArgs: CreateExtArgs): ProactiveAssistanceExtApi => {
        return {
            proactiveAssistance: {
                buildSiteContext: () => buildSiteContext(environmentContext, createExtArgs),
                extractContent: (containerPointer: Pointer) =>
                    getPageOutlineAndTargetsForBuilder(createExtArgs, containerPointer),
                analyze: (params: AnalyzeParams) => analyze(environmentContext, params)
            }
        }
    }

    const createPublicAPI = ({extensionAPI}: DmApis) => {
        const {proactiveAssistance} = extensionAPI as ProactiveAssistanceExtApi
        return {
            ai: {
                proactiveAssistance: {
                    buildSiteContext: proactiveAssistance.buildSiteContext,
                    extractContent: proactiveAssistance.extractContent,
                    analyze: proactiveAssistance.analyze
                }
            }
        }
    }

    return {
        name: 'proactiveAssistance',
        createExtensionAPI,
        createPublicAPI
    }
}

export {createExtension}
